import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'copyrightText',
  initialState: null as string | null,
  reducers: {
    setCopyrightText(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setCopyrightText } = slice.actions;
export default slice.reducer;
